import { createStore } from "vuex";

export default createStore({
  state: {
    listOfOrders: [],
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
